/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Day_ThuInputs */

const cs_portals_day_thu = /** @type {(inputs: Portals_Day_ThuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čt`)
};

const en_portals_day_thu = /** @type {(inputs: Portals_Day_ThuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thu`)
};

/**
* | output |
* | --- |
* | "Thu" |
*
* @param {Portals_Day_ThuInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_day_thu = /** @type {((inputs?: Portals_Day_ThuInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Day_ThuInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_day_thu(inputs)
	return cs_portals_day_thu(inputs)
});